module.exports = __webpack_public_path__ + "img/bigwin-text_en.0c95aec8.png";